export function GeoMap() {
  return (
    <div className="bg-slate-900 border border-slate-800 rounded-xl p-5">
      <div className="flex items-center justify-between mb-3">
        <h3 className="text-sm font-semibold text-slate-300 uppercase tracking-wider">State Tiers</h3>
      </div>
      <div className="flex flex-col items-center justify-center py-16 gap-3">
        <span className="text-5xl">🗺️</span>
        <p className="text-slate-300 font-medium text-sm">Coming soon</p>
        <p className="text-slate-500 text-xs text-center max-w-xs">
          Geo-based bid tier visualization will be available once geographic routing data is collected.
        </p>
      </div>
    </div>
  );
}
